import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

import { setMalls } from '../../../modules/dashboard/actions/creators'

import {
  setFavoriteMalls,
  displayProfileModal,
  setProfileModalPage,
  setSurveyModalStatus,
} from '../../../modules/profile/actions/creators'
import { setSelectedMallSlug } from '../../../modules/explore/actions/creators'

import { setFirebaseMessagingToken } from '../../../modules/auth/actions/creators'

import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import {
  doSubscribeToFirebaseMessaging,
  doSubscribeToFirebaseGuest,
} from '../../../controllers/Firebase'

const mapStateToProps = reduxState => {
  const { dashboard, profile, auth } = reduxState
  const { malls } = dashboard
  const { favoriteMalls, surveyModalStatus } = profile
  const { accessToken, firebaseMessagingToken } = auth
  const { deviceLocation } = dashboard

  return {
    malls,
    deviceLocation,
    favoriteMalls,
    accessToken,
    firebaseMessagingToken,
    doSubscribeToFirebaseMessaging,
    doSubscribeToFirebaseGuest,
    surveyModalStatus,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setMalls,
      setFavoriteMalls,
      setSelectedMallSlug,
      push,
      setFirebaseMessagingToken,
      displayProfileModal,
      setProfileModalPage,
      setSurveyModalStatus,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
